export default __webpack_public_path__ + "static/media/deliver.e179d65f.jpg";